import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useApi from "../../../core/customhook/useApi";
import axios, { AxiosError } from "axios";
import { apibaseurl, jwttoken } from "../../../environment";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import Loader from "../../../core/common/selfLoder";
import Select from "react-select";

const TravelRequest = () => {
  const [postloading, setPostloading] = useState(false);
  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  const navigate = useNavigate();
  const [expenseCategory, setExpenseCategory] =
    useState<string>("EXPC20251001");
  const [receipt, setReceipt] = useState<File | null>(null);

  const [formData, setFormData] = useState({
    expc_category_id: expenseCategory,
    costcenter_code: "",
    expc_title: "",
    expc_date: "",
    currency: "",
    amount: "",
    acc_country: "",
    acc_city: "",
    acc_check_in: "",
    acc_check_out: "",
    travel_trip_type: "",
    travel_mode: "",
    travel_class: "",
    travel_from_port: "",
    travel_to_port: "",
    travel_date_onward: "",
    travel_date_return: "",
    bill_no: "",
    merchant_name: "",
    comments: "",
  });

  const handleMainChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleReceiptChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setReceipt(e.target.files[0]);
    }
  };

  const {
    data: expanseCategory,
    loading: expansecategoryLoading,
    error: expansecategoryError,
  } = useApi("/api/master/get-expanse-category", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: costcenter,
    loading: costcenterLoading,
    error: costcenterError,
  } = useApi("/api/master/get-costcenter", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: currency,
    loading: currencyLoading,
    error: currencyError,
  } = useApi("/api/master/get-currency", {
    method: "GET",
    autoCall: true,
  });

  const expenseCategoryOptions =
    expanseCategory?.data?.map((item: any) => ({
      value: item.category_id,
      label: item.category_name,
    })) || [];
  const costCenterOptions =
    costcenter?.data.map((item: any) => ({
      value: item.costcentre_code,
      label: `${item.costcentre_code} - ${item.costcentre_name}`,
    })) || [];

  const currencyOptions =
    currency?.data?.map((item: any) => ({
      value: item.currency_id,
      label: item.currency_name,
    })) || [];

  const countryOptions = [
    { value: "united_states", label: "United States" },
    { value: "united_kingdom", label: "United Kingdom" },
    { value: "canada", label: "Canada" },
    { value: "germany", label: "Germany" },
    { value: "france", label: "France" },
    { value: "australia", label: "Australia" },
    { value: "india", label: "India" },
    { value: "uae", label: "United Arab Emirates" },
    { value: "japan", label: "Japan" },
    { value: "singapore", label: "Singapore" },
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      console.log(key, value);
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        key !== "receipt"
      ) {
        data.append(key, value);
      }
    });
    if (receipt) {
      data.append("receipt", receipt);
    }

    setPostloading(true);
    try {
      const response = await axios.post(
        `${apibaseurl}/api/expenses/add`,
        data,
        {
          headers: {
            Authorization: `Bearer ${jwttoken}`,
          },
        }
      );
      console.log(response);
      if (response.status === 201) {
        setPostloading(false);
        Swal.fire({
          title: "Success!",
          text: response.data.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/expense");
      }
    } catch (err) {
      setPostloading(false);

      const error = err as AxiosError<any>;

      Swal.fire({
        title: "Submission Failed",
        text: error?.response?.data?.message || "An unexpected error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  console.log(expanseCategory)
  return (
    <>
      <Loader
        loading={expansecategoryLoading || costcenterLoading}
      />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="card">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-center">
                <h2 className="text-center">Expense Request</h2>
              </div>
            </div>
          </div>

          <div className="row">
            {/* <div className="col-md-6">
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#2E3198",
                  borderRadius: "10px",
                  marginBottom: "10px",
                }}
              ></div>
            </div> */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    {/* Employee Name */}
                    <div className="row">
                      {/* Employee Name */}
                      <div className="col-md-6 mb-3">
                        <label
                          htmlFor="expc_category_id"
                          className="form-label"
                        >
                          <strong>Expense Category</strong>
                          <sup className="text-danger">*</sup>
                        </label>

                        <Select
                          inputId="expc_category_id"
                          name="expc_category_id"
                          options={expenseCategoryOptions}
                          value={expenseCategoryOptions.find(
                            (option: any) =>
                              option.value === formData.expc_category_id
                          )}
                          onChange={(selectedOption: any) => {
                            const value = selectedOption?.value || "";
                            setExpenseCategory(value);
                            setFormData((prev) => ({
                              ...prev,
                              expc_category_id: value,
                            }));
                          }}
                          placeholder="Select Expense Category"
                          classNamePrefix="custom-select"
                          styles={{
                            menu: (provided: any) => ({
                              ...provided,
                              maxHeight: 300,
                              overflowY: "auto",
                              scrollbarWidth: "none",
                            }),
                          }}
                        />
                      </div>

                      {/* Employee Id */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="costcenter_code" className="form-label">
                          <strong>Project/Cost Center</strong>
                          <sup className="text-danger">*</sup>
                        </label>
                        <Select
                          id="costcenter_code"
                          name="costcenter_code"
                          options={costCenterOptions}
                          onChange={(selectedOption: any) => {
                            handleMainChange({
                              target: {
                                name: "costcenter_code",
                                value: selectedOption?.value || "",
                              },
                            } as any);
                          }}
                          placeholder="Select Cost Center"
                          styles={{
                            menu: (provided: any) => ({
                              ...provided,
                              maxHeight: 250,
                              overflowY: "auto",
                              scrollbarWidth: "none",
                            }),
                          }}
                        />
                      </div>
                    </div>

                    <div className="row">
                      {/* Email */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="email" className="form-label">
                          <strong>Expense Title</strong>
                          <sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="expc_title"
                          name="expc_title"
                          placeholder="e.g., Hotel Stay, Flight Booking"
                          onChange={handleMainChange}
                        />
                      </div>

                      {/* Band */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="band" className="form-label">
                          <strong>Expense Date</strong>
                          <sup className="text-danger">*</sup>
                        </label>
                        <div className="input-icon-end position-relative">
                          <DatePicker
                            className="form-control datetimepicker"
                            format="DD-MM-YYYY"
                            getPopupContainer={getModalContainer}
                            placeholder="DD-MM-YYYY"
                            name="expc_date"
                            value={
                              formData.expc_date
                                ? dayjs(formData.expc_date, "DD-MM-YYYY")
                                : null
                            }
                            onChange={(date) =>
                              setFormData((prev) => ({
                                ...prev,
                                expc_date: date
                                  ? date.format("DD-MM-YYYY")
                                  : "",
                              }))
                            }
                          />
                          <span className="input-icon-addon">
                            <i className="ti ti-calendar text-gray-7" />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* Department */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="currency" className="form-label">
                          <strong>Currency</strong>
                          <sup className="text-danger">*</sup>
                        </label>

                        <Select
                          inputId="currency"
                          name="currency"
                          options={currencyOptions}
                          value={currencyOptions.find(
                            (option: any) => option.value === formData.currency
                          )}
                          onChange={(selectedOption: any) => {
                            const value = selectedOption?.value || "";
                            setFormData((prev) => ({
                              ...prev,
                              currency: value,
                            }));
                          }}
                          placeholder="Select a currency"
                          classNamePrefix="custom-select"
                          styles={{
                            menu: (provided: any) => ({
                              ...provided,
                              maxHeight: 250,
                              overflowY: "auto",
                              scrollbarWidth: "none",
                            }),
                          }}
                        />
                      </div>

                      {/* Designation */}
                      <div className="col-md-6 mb-3">
                        <label htmlFor="designation" className="form-label">
                          <strong>Amount</strong>
                          <sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="amount"
                          name="amount"
                          placeholder="Enter expense amount"
                          onChange={handleMainChange}
                        />
                      </div>
                    </div>

                    <div className="row">
                      {/* Date of Travel (From) */}
                      {expenseCategory === "EXPC20251001" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="acc_country" className="form-label">
                            <strong>Accommodation Country</strong>
                            <sup className="text-danger">*</sup>
                          </label>

                          <Select
                            inputId="acc_country"
                            name="acc_country"
                            options={countryOptions}
                            value={countryOptions.find(
                              (option: any) =>
                                option.value === formData.acc_country
                            )}
                            onChange={(selectedOption: any) => {
                              setFormData((prev) => ({
                                ...prev,
                                acc_country: selectedOption?.value || "",
                              }));
                            }}
                            placeholder="Select a Country"
                            styles={{
                              menu: (provided: any) => ({
                                ...provided,
                                maxHeight: 250,
                                overflowY: "auto",
                                scrollbarWidth: "none",
                              }),
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {/* Date of Travel (To) */}
                      {expenseCategory === "EXPC20251001" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date_to" className="form-label">
                            <strong>Accommodation City</strong>
                            <sup className="text-danger">*</sup>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="acc_city"
                            name="acc_city"
                            placeholder="Enter the city of accommodation"
                            onChange={handleMainChange}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="row">
                      {/* Date of Travel (From) */}
                      {expenseCategory === "EXPC20251001" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date_from" className="form-label">
                            <strong>Check in</strong>
                            <sup className="text-danger">*</sup>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format="DD-MM-YYYY"
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              name="acc_check_in"
                              value={
                                formData.acc_check_in
                                  ? dayjs(formData.acc_check_in, "DD-MM-YYYY")
                                  : null
                              }
                              onChange={(date) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  acc_check_in: date
                                    ? date.format("DD-MM-YYYY")
                                    : "",
                                }))
                              }
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {/* Date of Travel (To) */}
                      {expenseCategory === "EXPC20251001" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date_to" className="form-label">
                            <strong>Check out</strong>
                            <sup className="text-danger">*</sup>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format="DD-MM-YYYY"
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              name="acc_check_out"
                              value={
                                formData.acc_check_out
                                  ? dayjs(formData.acc_check_out, "DD-MM-YYYY")
                                  : null
                              }
                              onChange={(date) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  acc_check_out: date
                                    ? date.format("DD-MM-YYYY")
                                    : "",
                                }))
                              }
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="row">
                      {/* Date of Travel (From) */}
                      {expenseCategory === "EXPC20251002" ? (
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="travel_trip_type"
                            className="form-label"
                          >
                            <strong>Trip Type</strong>
                            <sup className="text-danger">*</sup>
                          </label>
                          <select
                            className="form-control"
                            id="travel_trip_type"
                            name="travel_trip_type"
                            onChange={handleMainChange}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select trip type
                            </option>
                            <option value="One Way">One Way</option>
                            <option value="Round Trip">Round Trip</option>
                          </select>
                        </div>
                      ) : (
                        ""
                      )}

                      {/* Date of Travel (To) */}
                      {expenseCategory === "EXPC20251002" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date_to" className="form-label">
                            <strong>Mode Of Travel</strong>
                            <sup className="text-danger">*</sup>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="travel_mode"
                            name="travel_mode"
                            placeholder="e.g., Airplane, Train"
                            onChange={handleMainChange}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="row">
                      {/* Date of Travel (From) */}
                      {expenseCategory === "EXPC20251002" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date_from" className="form-label">
                            <strong>Class Of Travel</strong>
                            <sup className="text-danger">*</sup>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="travel_class"
                            name="travel_class"
                            placeholder="e.g., Economy, Business"
                            onChange={handleMainChange}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="row">
                      {/* Date of Travel (From) */}
                      {expenseCategory === "EXPC20251002" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date_from" className="form-label">
                            <strong>From</strong>
                            <sup className="text-danger">*</sup>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="travel_from_port"
                            name="travel_from_port"
                            placeholder="Departure city"
                            onChange={handleMainChange}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {/* Date of Travel (To) */}
                      {expenseCategory === "EXPC20251002" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date_to" className="form-label">
                            <strong>To</strong>
                            <sup className="text-danger">*</sup>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="travel_to_port"
                            name="travel_to_port"
                            placeholder="Arrival city"
                            onChange={handleMainChange}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="row">
                      {/* Date of Travel (From) */}
                      {expenseCategory === "EXPC20251002" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date_from" className="form-label">
                            <strong>Date of onward journey</strong>
                            <sup className="text-danger">*</sup>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format="DD-MM-YYYY"
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              name="travel_date_onward"
                              value={
                                formData.travel_date_onward
                                  ? dayjs(
                                    formData.travel_date_onward,
                                    "DD-MM-YYYY"
                                  )
                                  : null
                              }
                              onChange={(date) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  travel_date_onward: date
                                    ? date.format("DD-MM-YYYY")
                                    : "",
                                }))
                              }

                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {/* Date of Travel (To) */}
                      {expenseCategory === "EXPC20251002" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date_to" className="form-label">
                            <strong>Date of return journey</strong>
                            <sup className="text-danger">*</sup>
                          </label>
                          <div className="input-icon-end position-relative">
                            <DatePicker
                              className="form-control datetimepicker"
                              format="DD-MM-YYYY"
                              getPopupContainer={getModalContainer}
                              placeholder="DD-MM-YYYY"
                              name="travel_date_return"
                              value={
                                formData.travel_date_return
                                  ? dayjs(
                                    formData.travel_date_return,
                                    "DD-MM-YYYY"
                                  )
                                  : null
                              }
                              onChange={(date) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  travel_date_return: date
                                    ? date.format("DD-MM-YYYY")
                                    : "",
                                }))
                              }
                            />
                            <span className="input-icon-addon">
                              <i className="ti ti-calendar text-gray-7" />
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="row">
                      {/* Date of Travel (From) */}
                      {expenseCategory === "EXPC20251003" ||
                        expenseCategory === "EXPC20251004" ||
                        expenseCategory === "EXPC20251005" ||
                        expenseCategory === "EXPC20251006" ||
                        expenseCategory === "EXPC20251007" ||
                        expenseCategory === "EXPC20251008" ||
                        expenseCategory === "EXPC20251009" ||
                        expenseCategory === "EXPC20251010" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date_from" className="form-label">
                            <strong>Bill Number</strong>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="bill_no"
                            name="bill_no"
                            placeholder="Enter bill/invoice number"
                            onChange={handleMainChange}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {/* Date of Travel (To) */}
                      {expenseCategory === "EXPC20251003" ||
                        expenseCategory === "EXPC20251004" ||
                        expenseCategory === "EXPC20251005" ||
                        expenseCategory === "EXPC20251006" ||
                        expenseCategory === "EXPC20251007" ||
                        expenseCategory === "EXPC20251008" ||
                        expenseCategory === "EXPC20251009" ||
                        expenseCategory === "EXPC20251010" ? (
                        <div className="col-md-6 mb-3">
                          <label htmlFor="date_to" className="form-label">
                            <strong>Merchant Name</strong>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="merchant_name"
                            name="merchant_name"
                            placeholder="Enter the merchant or vendor name"
                            onChange={handleMainChange}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* comments for Travel */}
                    <div className="mb-3">
                      <label htmlFor="comments" className="form-label">
                        <strong>Comment</strong>
                        <sup className="text-danger">*</sup>
                      </label>
                      <textarea
                        className="form-control"
                        id="comments"
                        name="comments"
                        onChange={(e) =>
                          setFormData({ ...formData, comments: e.target.value })
                        }
                        placeholder="Enter comments of Travel"
                        required
                      />
                    </div>

                    <div className="row">
                      {/* Date of Travel (From) */}
                      <div className="col-md-12 mb-3">
                        <label htmlFor="date_from" className="form-label">
                          <strong>Upload Bill / Documents</strong>
                          <sup className="text-danger">*</sup>
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          name="receipt"
                          onChange={handleReceiptChange}
                        />
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="mb-3">
                      <button type="submit" className="btn btn-primary custom_button">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default TravelRequest;
